import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map, forkJoin } from 'rxjs';
// import resolveResponse from 'contentful-resolve-response';

interface CardData {
  title: any;
  slug: any;
}

interface ApiResponse {
  items: Array<{ fields: CardData }>;
}

interface CategorizedData {
  iAmHere: CardData[];
  valuedBenefits: CardData[];
  edr: CardData[];
}

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  private spaceId = 'gbhr96tejqwq';

  private accessToken = '-OOfUdP_OLqKq2THzjtaCaqPo-KTJmnSo7A_o660pdY';

  private apiUrl = `https://cdn.contentful.com/spaces/${this.spaceId}/entries`;

  constructor(private http: HttpClient) {}

  // getContentEntry(entryId: string): Observable<any> {
  //   const headers = new HttpHeaders({
  //     Authorization: `Bearer ${this.accessToken}`,
  //   });

  //   const params = new HttpParams()
  //     .set('sys.id', entryId)
  //     .set('include', 3)
  //     .set('access_token', this.accessToken);

  //   return this.http
  //     .get(this.apiUrl, { headers, params })
  //     .pipe(map((data) => resolveResponse(data)));
  // }

  // getTitleAndSlugs(): Observable<CategorizedData> {
  //   const headers = new HttpHeaders({
  //     Authorization: `Bearer ${this.accessToken}`,
  //   });

  //   const makeRequest = (contentType: string): Observable<ApiResponse> => {
  //     const params = new HttpParams()
  //       .set('content_type', contentType)
  //       .set('access_token', this.accessToken);

  //     return this.http.get<ApiResponse>(this.apiUrl, { headers, params });
  //   };

  //   return forkJoin({
  //     iAmHere: makeRequest('tbCategoryPage'),
  //     valuedBenefits: makeRequest('tbValuedBenefitsPage'),
  //     edr: makeRequest('tbEdr'),
  //   }).pipe(
  //     map((responses: { [key: string]: ApiResponse }) => {
  //       const categorizedData: CategorizedData = {
  //         iAmHere: [],
  //         valuedBenefits: [],
  //         edr: [],
  //       };

  //       Object.entries(responses).forEach(([key, response]) => {
  //         response.items.forEach((item) => {
  //           const entry: CardData = {
  //             title: item.fields.title,
  //             slug: item.fields.slug,
  //           };
  //           categorizedData[key as keyof CategorizedData].push(entry);
  //         });
  //       });

  //       return categorizedData;
  //     }),
  //   );
  // }

  // getContentEntryBySlug(contentType: string, slug: string): Observable<any> {
  //   const headers = new HttpHeaders({
  //     Authorization: `Bearer ${this.accessToken}`,
  //   });
  //   const params = new HttpParams()
  //     .set('content_type', contentType)
  //     .set('fields.slug', slug)
  //     .set('include', 3)
  //     .set('access_token', this.accessToken);

  //   return this.http
  //     .get(this.apiUrl, { headers, params })
  //     .pipe(map((data) => resolveResponse(data)));
  // }

  getContentById(entryId: string): Observable<any> {
    return this.http.get(`/api/content/${entryId}?include=3`);
  }

  getContentBySlug(contentType: string, slug: string): Observable<any> {
    const token = localStorage.getItem('team-benefits-sso-token');
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.get(`/api/content/${contentType}/${slug}?include=3`, {
      headers,
    });
  }
}
